import * as React from 'react';
/**
 *
 * Original name: space
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=2916%3A1002
 *
 */
export const SpaceLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11 4h.75c5.215 0 7.75 2.535 7.75 7.75s-2.535 7.75-7.75 7.75c-3.668 0-6.06-1.326-7.109-3.943l-.25-.616L11 11.306V4ZM6.316 15.595C7.239 17.232 8.986 18 11.75 18c4.323 0 6.25-1.927 6.25-6.25 0-4.064-1.704-6.01-5.5-6.229v6.673l-6.184 3.4Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" }),
    React.createElement("path", { d: "M9.5 5.724c-2.746.619-4 2.544-4 6.026 0 .296.011.58.03.854l-1.43.786a13.42 13.42 0 0 1-.1-1.64c0-4.396 1.81-6.881 5.5-7.554v1.529Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
